import React, { useEffect } from 'react'
import Input from "../../../../../../core/Inputs/DefaultInput";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { updateStaticField } from '../../../../../../store/actions/formBuilderAction';
import { useTranslation } from 'react-i18next';



const FormBuilderHeader = ({ language_code, survey_id, leadGenData }) => {

    //States
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();


    //Yup
    let shape = {
        heading: Yup.string().required('Heading required'),
        description: Yup.string().required('Description required'),
    }
    const formSchema = Yup.object().shape(shape)

    //Formik
    let initialValues = {
        heading: '',
        description: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: formSchema
    })

    const { values, handleChange, handleBlur, touched, errors, setFieldValue } = formik

    //Functionalities
    const handleFieldBlur = (e, type, value) => {
        handleBlur(e)
        if (value) {
            const payload = {
                language_code,
                label: value,
                name: type,
                options: { options: null },
                survey_id
            }
            dispatch(updateStaticField(payload))
        }
    }

    //Effects
    useEffect(() => {
        if (leadGenData) {
            let heading = leadGenData.filter((field) => field.su_name === 'HEADING' && Number(field.su_form_variable_type) === 99)
            heading = heading ? heading[0] : null
            let desc = leadGenData.filter((field) => field.su_name === 'DESC' && Number(field.su_form_variable_type) === 99)
            desc = desc ? desc[0] : null
            setFieldValue('heading', heading?.su_label_and_options && (JSON.parse(heading?.su_label_and_options)[language_code] ?? ''))
            setFieldValue('description', desc?.su_label_and_options && (JSON.parse(desc?.su_label_and_options)[language_code] ?? ''))
        }
    }, [language_code, leadGenData])

    return (
        <>
            <div className="form-field-wrapper d-flex mb__20 heading">
                <div className="input-wrap flex-grow-1 position-relative">
                    <Input
                        type='text'
                        view='outlined'
                        dense={false}
                        color='default'
                        label=''
                        placeholder={t('survey.builder.add_heading')}
                        success={false}
                        error={false}
                        fill={true}
                        errorHelperText={null}
                        className={"formsinput"}
                        name='heading'
                        value={values.heading}
                        onChange={window.modulePermissions.M12.edit == 1 ? handleChange : undefined}
                        onBlur={window.modulePermissions.M12.edit == 1 ? (e) => handleFieldBlur(e, 'HEADING', values.heading) : undefined}
                        readOnly={window.modulePermissions.M12.edit != 1}
                    />
                    {touched.heading && errors.heading && <div className='validation-msg'>{errors.heading}</div>}
                </div>
                <div className="action-wrap action-mob"></div>
            </div>
            <div className="form-field-wrapper d-flex mb__20">
                <div className="input-wrap flex-grow-1 position-relative">
                    <Input
                        type='text'
                        view='outlined'
                        dense={false}
                        color='default'
                        label=''
                        placeholder={t('survey.builder.add_description')}
                        success={false}
                        error={false}
                        fill={true}
                        errorHelperText={null}
                        className={"formsinput"}
                        name='description'
                        value={values.description}
                        onChange={window.modulePermissions.M12.edit == 1 ? handleChange : undefined}
                        onBlur={window.modulePermissions.M12.edit == 1 ? (e) => handleFieldBlur(e, 'DESC', values.description) : undefined}
                        readOnly={window.modulePermissions.M12.edit != 1}
                    />
                    {touched.description && errors.description && <div className='validation-msg'>{errors.description}</div>}
                </div>
                <div className="action-wrap action-mob"></div>
            </div>
        </>
    )
}

export default FormBuilderHeader